import styled from "styled-components";

import {
    H1_2XL_New,
    H2New,
    H4New,
    breakpoints,
    colors,
    NewBlackButton,
    regular as regularFontWeight
} from "../index";

export const HeroTextH1 = styled(H1_2XL_New)`
    text-align: center;
    width: 100%;
    margin: 0 auto;
    color: ${colors.dark};

    /* Mobile: */
    max-width: 15rem; /* 240px */

    /* Tablet: */
    @media (min-width: ${breakpoints.md}rem) {
        max-width: 41.5rem; /* 664px */
    }

    /* Desktop: */
    @media (min-width: ${breakpoints.lg}rem) {
        max-width: 57.75rem; /* 924px */
    }

    /* Screens with 700px - 1000px height range - matches tablet: */
    @media ${breakpoints.laptopHeightsRange} {
        @media (min-width: ${breakpoints.lg}rem) {
            max-width: 41.5rem; /* 664px */
        }
    }
`;

export const HeroTextH2 = styled(H2New)`
    color: ${colors.dark};
`;

export const HeroTextH4 = styled(H4New)`
    margin: 0 auto;
    width: 100%;
    text-align: center;
    color: ${colors.dark};

    /* Tablet: */
    @media (min-width: ${breakpoints.md}rem) {
        max-width: 36.75rem; /* 588px */
    }

    /* Desktop: */
    @media (min-width: ${breakpoints.lg}rem) {
        max-width: 45.75rem; /* 732px */
    }

    /* Screens with 700px - 1000px height range - matches tablet: */
    @media ${breakpoints.laptopHeightsRange} {
        @media (min-width: ${breakpoints.lg}rem) {
            max-width: 36.75rem; /* 588px */
        }
    }
`;

export const Paragraph = styled.p`
    padding-top: 2rem; /* 32px */
    font-size: 1rem; /* 16px */
    line-height: 1.625rem; /* 26px */
    color: ${colors.dark};
    text-align: center;
    ${regularFontWeight}
`;

export const CTAsection = styled.div`
    text-align: center;
    padding-top: 2rem; /* 32px */

    ${NewBlackButton} {
        padding-top: 1.063rem; /* 17px */
        padding-bottom: 1.063rem; /* 17px */
    }
`;
